import { Industry, PaginatedIndustries } from '@app/modules/shared/models/industries';

export interface IIndustryState {
  industry: Industry;
  industries: Industry[];
  paginatedIndustries: PaginatedIndustries;
  success: string;
  error: string;
}

export const initialIndustryState: IIndustryState = {
  industry: null,
  industries: [],
  paginatedIndustries: null,
  success: '',
  error: ''
};
